import type { DeliveryMethodKind } from "@dransay/api/models";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { formatDeliveryPriceLabel } from "./format-delivery-price.logic";
import { useCurrencyPrice } from "./use-currency-price.hook";

interface FormatDeliveryPriceOptions {
	deliveryPrice?: number | null;
	deliveryMethodKind?: DeliveryMethodKind;
	totalPrice: number;
	deliveryMethodFreeFrom?: number | null;
	className?: string;
}

export function useFormatDeliveryPrice({
	deliveryPrice,
	deliveryMethodKind,
	totalPrice,
	deliveryMethodFreeFrom,
	className = "text-h5",
}: FormatDeliveryPriceOptions) {
	const { t } = useTranslation("common");
	const { getCurrencyPrice } = useCurrencyPrice();

	const price = useMemo(
		() =>
			formatDeliveryPriceLabel({
				deliveryPrice,
				deliveryMethodKind,
				totalPrice,
				deliveryMethodFreeFrom,
				formatCurrency: getCurrencyPrice,
				pendingPriceLabel: t("pricePending"),
			}),
		[
			t,
			totalPrice,
			deliveryMethodFreeFrom,
			getCurrencyPrice,
			deliveryPrice,
			deliveryMethodKind,
		],
	);

	return () => (
		<div className={`flex gap-2 whitespace-nowrap ${className}`}>
			{price.before && (
				<span className="line-through text-gray-500">{price.before}</span>
			)}
			<span>{price.after}</span>
		</div>
	);
}
